
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/client_needs",
      function () {
        return require("private-next-pages/client_needs/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/client_needs"])
      });
    }
  